import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import headingBg from 'assets/images/bg/title-register.jpg';

const accountOptionStyles = {
    wrap: css`
        padding: 10px;
        color: ${colors.white};
    `,
    mw800: css`
        max-width: 100%;
        background: ${colors.white};
        /* padding: 20px 20px; */
        border-radius: 0 0 5px 5px;
        .qrCode {
            display: flex;
            flex-direction: column;
        }
        .hidden {
            display: none;
        }
    `,
    title: css`
        font-size: 20px;
        margin-bottom: 20px;
        color: ${colors.white};
        padding: 10px 10px 20px;
        background: linear-gradient(to bottom, #B80005, #710003);
        border-radius: 5px;
        position: relative;
        text-transform: uppercase;
        &::after {
            position: absolute;
            bottom: 10px;
            left: 10px;
            content: "";
            width: calc(100% - 20px);
            height: 1px;
            background: rgba(255, 255, 255, .3);
        }
    `,
    label: css`
        display: block;
        font-size: 14px;
        margin-bottom: 6px;
    `,
    addBank: css`
        p {
            color: #000;
        }
    `,
    heading: css`
        background: url(${headingBg}) no-repeat;
        background-size: cover;
        width: 100%;
        border-radius: 8px;
        align-items: center;
        padding: 10px 12px;
        border: 1px solid ${colors.borderPrimary};
        p {
            font-size: 14px;
        }
        span {
            color: ${colors.yellow};
            font-weight: 600;
        }
    `,
    accountName: css`
        display: flex;
        align-items: center;
        p {
            color: var(--text-black-color);
            margin-right: 12px;
        }
    `,
    groupInput: css`
        padding-bottom: 20px;
        position: relative;
        label {
            display: block;
            margin-bottom: 8px;
            padding-left: 10px;
            color: #212939;
        }
        input {
            width: 100%;
        }
        p {
            color: #000;
        }
        &.giftCode {
            max-width: 40%;
            margin: 0 auto;
        }
    `,
    flexbox: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 20px;
    `,
    btnCopy: css`
        display: flex;
        width: 24px !important;
        padding: 4px;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
            background: ${colors.primary} !important;
        }

        img {
            width: 100%;
        }
    `,
    flex50: css`
        flex: 0 0 calc(50% - 25px);
        max-width: calc(50% - 25px);
    `,
    flex33: css`
        flex: 0 0 calc(calc(100% / 3) - 12px);
    `,
    groupPass: css`
        padding-top: 16px;
        border-top: 1px solid #ccc;
        align-items: flex-end;
    `,
    btnSubmit: css`
        padding: 10px 0;
        font-weight: 600;
        border-radius: 8px;
        cursor: pointer;
        margin: 0 auto;
        &.btn-reg {
            background: var(--white-color);
            box-shadow: 0 2px 2px rgba(var(--black-color), .3);
            &:hover {
                background: var(--primary-color);
                color: var(--white-color);
            }
        }
    `,
    elmSubmit: css`
        max-width: 40%;
        margin: 15px auto;
    `,
    wrapInput: css`
        position: relative;
        height: 40px;
        input {
            height: 100%;
            padding: 0 12px;
            color: #164F3F;
            background: #fff;
            border: 1px solid #DEDEDE;
        }
    `,
    btnUpdateInput: css`
        position: absolute;
        top: 6px;
        right: 10px;
        border-radius: 8px;
        font-size: 12px;
        color: #fff;
        height: calc(100% - 12px);
        padding: 0 10px;
        border: 0;
        cursor: pointer;
        background: linear-gradient(to bottom, #B80005, #710003);
        transition: 0.2s;
        &:hover {
            background: ${colors.primary};
        }
    `,
    btnVerify: css`
        border: 1px solid ${colors.yellow};
    `,
    verified: css`
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
        display: flex;
        align-items: center;
        img {
            width: 16px;
        }
        span {
            font-size: 12px;
            margin-left: 4px;
            color: ${colors.success};
        }
    `,
    qrcodeWrap: css`
        display: flex;
        align-items: center;
        gap: 20px;
        padding: 10px;
        background: var(--gradient-primary);
        border-radius: 8px;
        border: 1px solid ${colors.borderPrimary};
        width: 52%;
    `,
    qrCode: css`
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
    `,
    agentQr: css`
        width: 40%;
        > div {
            margin-top: 20px;
        }
        p {
            color: var(--text-black-color);
        }
    `,
    agentItem: css`
        display: flex;
        color: var(--primary-color);
        padding: 5px 12px;
        border: 1px solid #DEDEDE;
        border-radius: 5px;
        margin-top: 10px;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        .btn-primary {
            width: 110px;
            padding: 5px 10px;
            border-radius: 5px;
            display: flex;
            align-items: center;
            img {
                width: 15px;
                margin-right: 5px;
            }
        }
    `,
    qrcodeIcon: css`
        border-radius: 12px;
        overflow: hidden;
        display: flex;
        flex: 0 0 160px;
        max-width: 160px;
    `,
    ruleQr: css`
        ul {
            padding-left: 15px;
        }
        li {
            margin-bottom: 4px;
            font-size: 15px;
            color: #fff;
        }
    `,
    generateQr: css`
        padding-left: 32px;
        color: ${colors.primary};
        li {
            margin-bottom: 4px;
        }
        span {
            color: ${colors.red};
            font-weight: 500;
        }
    `,
};
export default accountOptionStyles;
